import React, { useState, useEffect } from "react";
import FloorList from "./components/FloorList";
import axios from "axios";
import { createFloorApi, getFloorsApi, updateFloorApi } from "./Api";

const RestaurantFloorScreen = (props) => {
  const restaurantId = props.match.params.id;

  const [newFloorName, setNewFloorName] = useState("");
  const [isEditingName, setIsEditingName] = useState(false);
  const [loading, setLoading] = useState(false);
  const [floorsArray, setFloorsArray] = useState([]);
  const [FloorId, setFloorId] = useState(false);
  const [restaurant, setRestaurant] = useState([]);

  const getFloors = async () => {
    setLoading(true);
    const floors = await getFloorsApi(restaurantId);
    console.log("Data is", floors?.data);
    setLoading(false);
    setFloorsArray(floors?.data?.data);
  };

  const createFloorFunc = async () => {
    setLoading(true);
    let data = {
      floor_name: newFloorName,
      restaurantId: restaurantId,
    };

    const res = await createFloorApi(data);

    setLoading(false);
    return getFloors();
  };

  const updateFloorFunc = async () => {
    setLoading(true);
    let data = {
      floor_name: newFloorName,
    };

    const res = await updateFloorApi(FloorId, data);

    setLoading(false);
    return window.location.reload();
  };

  useEffect(() => {
    axios
      .get(
        `https://restoapp-super-admin.herokuapp.com/getRestaurantById/${restaurantId}`
      )
      .then((res) => {
        console.log(res.data.data);
        setRestaurant(res.data.data);
      });
    getFloors();
    return () => {};
  }, []);

  return (
    <div className="p-8 w-full bg-gray-100 min-h-screen ">
      <div className="my-4 text-md font-semibold text-gray-600 flex items-center">
        Flooring & Seating : {restaurant.restaurant_name}
      </div>

      <div className="w-full flex items-start justify-between">
        <div className="w-7/12 my-8">
          <FloorList
            setIsEditingName={setIsEditingName}
            setFloorId={setFloorId}
            floorsArray={floorsArray}
            setNewFloorName={setNewFloorName}
            restaurantId={restaurantId}
          />
        </div>

        <div className="w-4/12 my-8">
          <div className="bg-white rounded-md border border-gray-100 py-4 px-2 pt-2 shadow-md ">
            <div className="my-4 w-full text-center text-md font-semibold text-gray-600">
              {" "}
              Restaurant Floor Form
            </div>

            <div className="w-90% mx-auto flex-1 svelte-1l8159u">
              <div className="font-bold h-6 mt-3 text-gray-600 text-xs leading-8 uppercase">
                Floor Name ( Ground,1st etc)
              </div>
              <div className="bg-white my-4 p-1 flex border border-gray-200 rounded svelte-1l8159u">
                <input
                  defaultValue={newFloorName}
                  onChange={(e) => setNewFloorName(e.target.value)}
                  placeholder="Which floor is this ?"
                  className="p-1 px-2 appearance-none outline-none w-full text-gray-800"
                />
              </div>

              {isEditingName ? (
                <div>
                  <span
                    onClick={() => {
                      setIsEditingName(false);
                      setNewFloorName("");
                    }}
                    className="mr-4 cursor-pointer text-red-400 text-md font-semibold hover:text-red-600"
                  >
                    Cancel
                  </span>
                  <button
                    onClick={() => updateFloorFunc()}
                    className="my-5  transition-all  bg-indigo-400 hover:bg-green-400 text-white px-4 py-2 rounded-md"
                  >
                    {loading ? "Updating...." : "Update Name"}
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => createFloorFunc()}
                  className="my-5  text-white px-4 py-2 transition-all  bg-indigo-400 hover:bg-green-400 rounded-md"
                >
                  {loading ? "Loading...." : "Create Floor"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestaurantFloorScreen;
